import { render, staticRenderFns } from "./Reporte.vue?vue&type=template&id=67d67c64&scoped=true"
import script from "./Reporte.vue?vue&type=script&lang=js"
export * from "./Reporte.vue?vue&type=script&lang=js"
import style0 from "./Reporte.vue?vue&type=style&index=0&id=67d67c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d67c64",
  null
  
)

export default component.exports